export var IMPLEMENTATION_OPTION_TYPES;
(function (IMPLEMENTATION_OPTION_TYPES) {
    IMPLEMENTATION_OPTION_TYPES["SELF_GUIDED"] = "self_guided";
    IMPLEMENTATION_OPTION_TYPES["GUIDED"] = "guided";
})(IMPLEMENTATION_OPTION_TYPES || (IMPLEMENTATION_OPTION_TYPES = {}));
export const IMPLEMENTATION_OPTION_VALUES = Object.values(IMPLEMENTATION_OPTION_TYPES);
export var TAX_EXEMPT_STATUS;
(function (TAX_EXEMPT_STATUS) {
    TAX_EXEMPT_STATUS["EXEMPT"] = "exempt";
    TAX_EXEMPT_STATUS["REQUESTED"] = "requested";
    TAX_EXEMPT_STATUS["NON_EXEMPT"] = "non_exempt";
})(TAX_EXEMPT_STATUS || (TAX_EXEMPT_STATUS = {}));
export const TAX_EXEMPT_STATUS_VALUES = Object.values(TAX_EXEMPT_STATUS);
export const COMPANY_STATES = ['active', 'closed', 'suspended', 'billing_suspended', 'pending', 'deleted'];
export var ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES;
(function (ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES) {
    ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES["KEEP_PLAN"] = "keep_plan";
    ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES["DOWNGRADE"] = "downgrade";
    ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES["CANCEL"] = "cancel";
})(ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES || (ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES = {}));
export const ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS = Object.values(ANNUAL_SUBSCRIPTION_RENEWAL_ACTIONS_TYPES);
